import CryptoJS from 'crypto-js';

/**
 * Encrypts data using AES encryption
 * @param {string|object} data - Data to encrypt (will be stringified if object)
 * @param {string} secretKey - Secret key for encryption (defaults to env variable or fallback)
 * @returns {string} - Encrypted string
 */
export const encryptData = (data, secretKey = null) => {
	// Use environment variable if available, otherwise use a fallback key
	// In production, this should be stored in environment variables
	const key = secretKey || process.env.REACT_APP_ENCRYPTION_KEY || 'unclekam-default-encryption-key-2024';
	
	// Convert object to string if needed
	const dataString = typeof data === 'object' ? JSON.stringify(data) : data;
	
	// Encrypt the data
	const encrypted = CryptoJS.AES.encrypt(dataString, key).toString();
	
	return encrypted;
};

/**
 * Decrypts data using AES decryption
 * @param {string} encryptedData - Encrypted string to decrypt
 * @param {string} secretKey - Secret key for decryption (defaults to env variable or fallback)
 * @returns {string|object} - Decrypted data (parsed as JSON if possible)
 */
export const decryptData = (encryptedData, secretKey = null) => {
	// Use environment variable if available, otherwise use a fallback key
	const key = secretKey || process.env.REACT_APP_ENCRYPTION_KEY || 'unclekam-default-encryption-key-2024';
	
	// Decrypt the data
	const bytes = CryptoJS.AES.decrypt(encryptedData, key);
	const decrypted = bytes.toString(CryptoJS.enc.Utf8);
	
	// Try to parse as JSON, return as string if not valid JSON
	try {
		return JSON.parse(decrypted);
	} catch (e) {
		return decrypted;
	}
};
